<template>
  <div class="notFound">
      <h1 align="center">Not found <span>:(</span></h1>
      <p align="center">Sorry, but the page you were trying to view does not exist.</p>
      <h1 align="center" class="mt-5" style="font-size: 120px">404</h1>
  </div>
</template>

<script>
export default {
  name: 'notFound'
}
</script>
